var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBullet3NickelsUQa = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#02769D",
    strokeWidth: 2,
    fill: "#E7F3F9",
    cx: 25,
    cy: 25,
    r: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10h30v30H10z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 22.423c0-.765.644-1.385 1.434-1.385h11.22c.794 0 1.437.62 1.437 1.385v6.51c0 .765-.643 1.386-1.437 1.386H20.02L18.35 32l-1.422-1.68h-1.494c-.79 0-1.434-.622-1.434-1.387v-6.51z",
    stroke: "#02769D",
    strokeWidth: 1.2,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 26.506C36 27.33 35.245 28 34.312 28h-1.76l-1.672 1.806L28.913 28H21.1c-.934 0-1.69-.67-1.69-1.494v-7.014c0-.823.756-1.492 1.69-1.492h13.212c.933 0 1.688.669 1.688 1.492v7.014z",
    fill: "#02769D"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBullet3NickelsUQa);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bullet-3nickelsU-qa.89357c1b5c95bf0c0f8ec0f98fcf2d60.svg";